<template>
  <footer>
    <div class="container">
      <div class="top">
        <logo-container />
        <div class="mob">
          <div class="mobile">
            <nav class="nav-footer">
              <ul>
                <li><a href="/df/">Головна</a></li>
                <li><a href="/df/#about">Про проєкт</a></li>
                <li><a href="/df/#recruit-process">Процес рекрутингу</a></li>
                <li><a href="/df/#vacancy">Вакансії</a></li>
              </ul>
            </nav>
          </div>
          <div class="contacts">
            <a
              class="contact"
              v-for="item in itemsContact"
              :key="item.id"
              :href="item.link"
            >
              <img :src="getImageContactPath(item.icon)" alt="icon" />
              <p>{{ item.title }}</p>
            </a>
            <div class="socials">
              <p>Корисні посилання:</p>
              <a
                v-for="item in itemsSocial"
                :key="item.id"
                target="_blank"
                :href="item.link"
                class="social-item"
              >
                <img :src="getImageSocialPath(item.icon)" alt="icon" />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom">
        <nav class="nav-footer desktop">
          <ul>
            <li><a href="/df/">Головна</a></li>
            <li><a href="/df/#about">Про проєкт</a></li>
            <li><a href="/df/#recruit-process">Процес рекрутингу</a></li>
            <li><a href="/df/#vacancy">Вакансії</a></li>
          </ul>
        </nav>
        <div class="copyright">
          <p class="mobile">Copyright</p>
          <p>&#169;</p>
          <p>{{ new Date().getFullYear() }}</p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import LogoContainer from "@/components/page/modules/LogoContainer.vue";

export default {
  name: "custom-footer",
  components: {
    LogoContainer,
  },
  data() {
    return {
      itemsContact: [
        {
          id: 1,
          icon: "phone",
          title: "0 800 301 314",
          link: "tel:0800301314",
        },
        {
          id: 2,
          icon: "phone",
          title: "+380 67 678 32 28",
          link: "tel:+380676783228",
        },
        {
          id: 3,
          icon: "mail",
          title: "rc.sv.zsu@gmail.com",
          link: "mailto:rc.sv.zsu@gmail.com",
        },
      ],
      itemsSocial: [
        {
          id: 1,
          icon: "fb",
          link: "https://www.facebook.com/df.recruiting",
        },
        {
          id: 2,
          icon: "ig",
          link: "https://www.instagram.com/df_recruiting/",
        },
        {
          id: 3,
          icon: "rabota",
          link: "https://robota.ua/company0/vacancy10021475",
        },
        {
          id: 4,
          icon: "x",
          link: "https://lobbyx.army/tor/operator-bpla-do-sukhoputnykh-viysk/",
        },
        {
          id: 5,
          icon: "work",
          link: "https://www.work.ua/jobs/5652117/",
        },
      ],
    };
  },
  methods: {
    getImageContactPath(item) {
      return require(`@/assets/images/icons/${item}.svg`);
    },
    getImageSocialPath(item) {
      return require(`@/assets/images/icons/social/${item}.svg`);
    },
  },
};
</script>

<style lang="scss" scoped>
footer {
  background: #000;
  color: #fff;

  p,
  a,
  div {
    @media (max-width: 767px) {
      font-size: 14px !important;
    }
  }

  .container {
    margin-top: 0;
    padding: 44px 0;
  }

  .top {
    border-top: 2px solid #fff;
    border-bottom: 1px solid #fff;
    padding: 44px 0 67px;
    display: flex;
    align-items: flex-start;
    gap: 312px;

    @media (max-width: 767px) {
      gap: 0;
      flex-direction: column;
    }

    @media (min-width: 768px) and (max-width: 1360px) {
      gap: 0;
      justify-content: space-between;
    }
  }

  .mob {
    @media (max-width: 767px) {
      display: flex;
      margin-top: 20px;
      justify-content: space-between;
      width: 100%;

      ul {
        flex-direction: column;
        gap: 22px !important;
      }
    }
  }

  .bottom {
    padding-top: 22px;
    padding-bottom: 22px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .nav-footer {
    ul {
      display: flex;
      gap: 42px;

      li {
        list-style-type: none;

        a {
          color: white;
          text-decoration: none;
        }
      }
    }
  }
}
.contacts {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 55px;

  @media (max-width: 767px) {
    margin-top: 0;
  }
}
.contact {
  display: flex;
  gap: 10px;
  text-decoration: none;
  color: white;
  align-items: center;

  p {
    font-weight: 400;
    font-size: 14px;
    line-height: 100%;
  }
}

.socials {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-top: 25px;

  @media (max-width: 767px) {
    position: relative;
  }

  p {
    max-width: 84px;
    font-weight: 400;
    font-size: 14px;
    line-height: 100%;

    @media (max-width: 767px) {
      position: absolute;
      top: -24px;
      width: 100%;
      white-space: nowrap;
    }
  }
}

.copyright {
  display: flex;
  gap: 5px;
  align-items: center;

  @media (max-width: 767px) {
    margin: 0 auto;
  }
}

.mobile {
  @media (min-width: 768px) {
    display: none;
  }
}

.desktop {
  @media (max-width: 767px) {
    display: none;
  }
}
</style>
